// import {useState,useEffect} from "react";
// import { FaPlus, FaTrash, FaEdit, FaThLarge } from "react-icons/fa";
// import { useNavigate,useLocation } from "react-router-dom";
// import { MdGridView } from "react-icons/md";
// import  axios from "axios";

// import {
//   showSuccess,
//   showError,
// } from "../../General/Toast";



// const Units = ({clientData}) => {


// const [units, setUnits] = useState([]);
// const [showDeleteModal, setShowDeleteModal] = useState(false);
// const [conversionToDelete, setConversionToDelete] = useState(null);
// const [editMode, setEditMode] = useState(false);
// const [conversions, setConversions] = useState([]);
//    const [showFilter, setShowFilter] = useState(false);
// const [filterType, setFilterType] = useState("Products");
//  const navigate = useNavigate();
//    const location = useLocation();
//    const [showUnitModal, setShowUnitModal] = useState(false);
// const [unitName, setUnitName] = useState("");
// // const client_id = localStorage.getItem("client_id");
// const [showConversionModal, setShowConversionModal] = useState(false);

// const [conversionData, setConversionData] = useState({
//   p_unit: "",
//   s_unit: "",
//   value: ""
// });

// const client_id=clientData.id;
// const handleDeleteConversion = (item) => {
//   setConversionToDelete(item);
//   setShowDeleteModal(true);
// };
// const confirmDeleteConversion = async () => {
//   try {

//     await axios.delete(
//       `https://api.dectwinbilling.com/delete-conversion/${client_id}/${conversionToDelete.p_unit}/${conversionToDelete.s_unit}/${conversionToDelete.value}`
//     );

//     showSuccess("Conversion Deleted Successfully");

//     fetchConversions();

//     setShowDeleteModal(false);
//     setConversionToDelete(null);

//   } catch (error) {

//     showError(
//       error.response?.data?.message ||
//       "Delete Failed"
//     );
//   }
// };
// const fetchConversions = async () => {
//   try {
//     const response = await axios.get(
//       `https://api.dectwinbilling.com/fetch-conversion/${client_id}`
//     );

//     setConversions(response.data);
//   } catch (error) {
//     console.log(error);
//   }
// };
// // const handleEditConversion = (item) => {
// //   setEditMode(true);

// //   setConversionData({
// //     p_unit: item.p_unit,
// //     s_unit: item.s_unit,
// //     value: item.value
// //   });

// //   setShowConversionModal(true);
// // };
// const handleEditConversion = (item) => {
//   setEditMode(true);

//   setConversionData({
//     id: item.id,
//     p_unit: item.p_unit,
//     s_unit: item.s_unit,
//     value: item.value
//   });

//   setShowConversionModal(true);
// };
// const handleAddUnit = async () => {
//   if (!unitName.trim()) {
//     alert("Enter Unit Name");
//     return;
//   }

//   try {
//     await axios.post(
//       "https://api.dectwinbilling.com/add-category",
//       {
//         cat_name: unitName,
//         cat_type: "unit",
//         client_id,
//       }
//     );

//       showSuccess("Unit Added Successfully");

//     setUnitName("");
//     setShowUnitModal(false);

//     fetchUnits(); 

//   } catch (error) {
//     showError(
//       error.response?.data?.message ||
//       "Something went wrong"
//     );
//   }
// };
// // const handleAddConversion = async () => {
// //   try {

// //     if (
// //       !conversionData.p_unit ||
// //       !conversionData.s_unit ||
// //       !conversionData.value
// //     ) {
// //       showError("Fill all fields");
// //       return;
// //     }

// //     await axios.post(
// //       "https://api.dectwinbilling.com/add-conversion",
// //       {
// //         p_unit: conversionData.p_unit,
// //         s_unit: conversionData.s_unit,
// //         value: conversionData.value,
// //         client_id
// //       }
// //     );

// //     showSuccess("Conversion Added Successfully");
// //     fetchConversions();

// //     setConversionData({
// //       p_unit: "",
// //       s_unit: "",
// //       value: ""
// //     });

// //     setShowConversionModal(false);

// //   } catch (error) {
// //     showError(
// //       error.response?.data?.message ||
// //       "Something went wrong"
// //     );
// //   }
// // };
// const handleAddConversion = async () => {
//   try {

//     if (
//       !conversionData.p_unit ||
//       !conversionData.s_unit ||
//       !conversionData.value
//     ) {
//       showError("Fill all fields");
//       return;
//     }

//     if (editMode) {

//       await axios.put(
//         "https://api.dectwinbilling.com/edit-conversion",
//         {
//           p_unit: conversionData.p_unit,
//           s_unit: conversionData.s_unit,
//           value: conversionData.value,
//           client_id
//         }
//       );

//       showSuccess("Conversion Updated Successfully");

//     } else {

//       await axios.post(
//         "https://api.dectwinbilling.com/add-conversion",
//         {
//           p_unit: conversionData.p_unit,
//           s_unit: conversionData.s_unit,
//           value: conversionData.value,
//           client_id
//         }
//       );

//       showSuccess("Conversion Added Successfully");
//     }

//     fetchConversions();

//     setConversionData({
//       p_unit: "",
//       s_unit: "",
//       value: ""
//     });

//     setEditMode(false);

//     setShowConversionModal(false);

//   } catch (error) {

//     showError(
//       error.response?.data?.message ||
//       "Something went wrong"
//     );

//   }
// };
// const handleDeleteUnit = async (unitName) => {
//   try {
//     await axios.delete(
//       `https://api.dectwinbilling.com/delete-unit/${client_id}/${unitName}`
//     );

//     fetchUnits();
//       showSuccess("Unit Deleted Successfully");
//   } catch (error) {
//     alert(
//       error.response?.data?.message ||
//       "Delete Failed"
//     );
//   }
// };

// const fetchUnits = async () => {
//   try {
//     const response = await axios.get(
//       `https://api.dectwinbilling.com/fetch-unit/${client_id}`
//     );

//     setUnits(response.data);
//   } catch (error) {
//     console.log(error);
//   }
// };

// useEffect(() => {
//   fetchUnits();
//     fetchConversions();
// }, []);

// return (
  

// <div
// className="container-fluid min-vh-100 p-3"
// style={{
// background:"#f1f3f8"
// }}
// >




// <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between mb-3">

// <h4 className="fw-bold mb-0">
// Units
// </h4>



// <div className="d-flex gap-3">

// <button
//   className="btn text-white fw-semibold px-4"
//   style={{
//     background:"var(--primary-color)",
//     borderRadius:"12px"
//   }}
//   onClick={() => setShowUnitModal(true)}
// >
//   <FaPlus className="me-2"/>
//   Add Unit
// </button>


// <button
//   className="btn text-white fw-semibold px-4"
//   style={{
//     background: "var(--primary-color)",
//     borderRadius: "12px"
//   }}
//   onClick={() => {
//     setEditMode(false);

//     setConversionData({
//       p_unit: "",
//       s_unit: "",
//       value: ""
//     });

//     setShowConversionModal(true);
//   }}
// >
//   <FaPlus className="me-2"/>
//   Add Conversion
// </button>


//   <button
//     className="grid-btn"
//     onClick={() => setShowFilter(!showFilter)}
//   >
//     <MdGridView />
//   </button>
// {showDeleteModal && (
//   <div
//     className="modal fade show d-block"
//     style={{ background: "rgba(0,0,0,0.5)" }}
//   >
//     <div className="modal-dialog modal-dialog-centered">
//       <div
//         className="modal-content border-0"
//         style={{
//           borderRadius: "20px"
//         }}
//       >
//         <div className="modal-body text-center p-4">

//           <h4 className="fw-bold mb-3">
//             Delete Conversion
//           </h4>

//           <p className="text-muted">
//             Are you sure you want to delete this conversion?
//           </p>

//           <div className="d-flex justify-content-center gap-3 mt-4">

//             <button
//               className="btn btn-secondary px-4"
//               onClick={() => {
//                 setShowDeleteModal(false);
//                 setConversionToDelete(null);
//               }}
//             >
//               Cancel
//             </button>

//             <button
//               className="btn btn-danger px-4"
//               onClick={confirmDeleteConversion}
//             >
//               Delete
//             </button>

//           </div>

//         </div>
//       </div>
//     </div>
//   </div>
// )}
//  {showUnitModal && (
//   <>
//     <div
//       className="modal fade show d-block"
//       tabIndex="-1"
//       style={{ background: "rgba(0,0,0,0.5)" }}
//     >
//  <div
//   className="modal-dialog modal-dialog-centered mx-auto"
//   style={{
//     maxWidth: "500px",
//     width: "95%"
//   }}
// >
//         <div
//           className="modal-content border-0"
//           style={{
//             borderRadius: "25px",
//             background: "#f4f1f4"
//           }}
//         >
//          <div className="modal-body p-3 p-md-4">

//             <h3 className="text-center fw-bold mb-4">
//               Add Unit
//             </h3>

//             <div
//               className="d-flex align-items-center px-3 py-3 mb-4"
//               style={{
//                 background: "#ddd9dd",
//                 borderRadius: "15px"
//               }}
//             >
//               <label className="fw-bold me-2 mb-0">
//                 Unit Name :
//               </label>

//               <input
//                 type="text"
//                 className="form-control border-0 bg-transparent shadow-none"
//                 placeholder="Enter Unit Name"
//                 value={unitName}
//                 onChange={(e) =>
//                   setUnitName(e.target.value)
//                 }
//               />
//             </div>

//             <div className="d-flex justify-content-center gap-3">

//               <button
//                 className="btn btn-light px-4"
//                 style={{ borderRadius: "20px" }}
//                 onClick={() => setShowUnitModal(false)}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="btn btn-light px-4"
//                 style={{
//                   borderRadius: "20px",
//                   color: "#6c4ccf"
//                 }}
//                 onClick={handleAddUnit}
//               >
//                 Add
//               </button>

//             </div>

//           </div>
//         </div>
//       </div>
//     </div>
//   </>
// )}
// {showConversionModal && (
//   <div
//     className="modal fade show d-block"
//     style={{ background: "rgba(0,0,0,.5)" }}
//   >
//     <div className="modal-dialog modal-dialog-centered">
//       <div
//         className="modal-content border-0"
//         style={{
//           borderRadius: "25px",
//           background: "#f4f1f4"
//         }}
//       >
//    <div className="modal-body p-4">

//   <h4 className="fw-bold mb-4">
//     {editMode
//       ? "Edit Unit Conversion"
//       : "Add Unit Conversion"}
//   </h4>

//   {/* Primary Unit */}
//   <div className="mb-3">
//     <label className="fw-semibold mb-2">
//       Primary Unit
//     </label>

//     {/* <select
//       className="form-select py-3"
//       style={{
//         borderRadius: "15px",
//         background: "#ddd9dd",
//         border: "none"
//       }}
//       value={conversionData.p_unit}
//       onChange={(e) =>
//         setConversionData({
//           ...conversionData,
//           p_unit: e.target.value
//         })
//       }
//     >
//       <option value="">Select Primary Unit</option>

//       {units.map((unit) => (
//         <option key={unit.id} value={unit.cat_name}>
//           {unit.cat_name}
//         </option>
//       ))}
//     </select> */}
//     <select
//   className="form-select py-3"
//   style={{
//     borderRadius: "15px",
//     background: "#ddd9dd",
//     border: "none"
//   }}
//   value={conversionData.p_unit}
//   disabled={editMode}
//   onChange={(e) =>
//     setConversionData({
//       ...conversionData,
//       p_unit: e.target.value
//     })
//   }
// >
//   <option value="">Select Primary Unit</option>

//   {units.map((unit) => (
//     <option key={unit.id} value={unit.cat_name}>
//       {unit.cat_name}
//     </option>
//   ))}
// </select>
//   </div>

//   {/* Secondary Unit */}
//   <div className="mb-3">
//     <label className="fw-semibold mb-2">
//       Secondary Unit
//     </label>

//     {/* <select
//       className="form-select py-3"
//       style={{
//         borderRadius: "15px",
//         background: "#ddd9dd",
//         border: "none"
//       }}
//       value={conversionData.s_unit}
//       onChange={(e) =>
//         setConversionData({
//           ...conversionData,
//           s_unit: e.target.value
//         })
//       }
//     >
//       <option value="">Select Secondary Unit</option>

//       {units.map((unit) => (
//         <option key={unit.id} value={unit.cat_name}>
//           {unit.cat_name}
//         </option>
//       ))}
//     </select> */}
//     <select
//   className="form-select py-3"
//   style={{
//     borderRadius: "15px",
//     background: "#ddd9dd",
//     border: "none"
//   }}
//   value={conversionData.s_unit}
//   disabled={editMode}
//   onChange={(e) =>
//     setConversionData({
//       ...conversionData,
//       s_unit: e.target.value
//     })
//   }
// >
//   <option value="">Select Secondary Unit</option>

//   {units.map((unit) => (
//     <option key={unit.id} value={unit.cat_name}>
//       {unit.cat_name}
//     </option>
//   ))}
// </select>
//   </div>

  
//   <div className="mb-4">
//     <label className="fw-semibold mb-2">
//       Unit Conversion
//     </label>

//     <input
//       type="text"
//       className="form-control py-3"
//       style={{
//         borderRadius: "15px",
//         background: "#ddd9dd",
//         border: "none"
//       }}
//       placeholder="Enter Here"
//       value={conversionData.value}
//       onChange={(e) =>
//         setConversionData({
//           ...conversionData,
//           value: e.target.value
//         })
//       }
//     />
//   </div>

//   <div className="d-flex justify-content-end gap-3">

//     <button
//       className="btn px-4"
//       style={{
//         borderRadius: "20px",
//         background: "#fff"
//       }}
//       onClick={() => setShowConversionModal(false)}
//     >
//       Cancel
//     </button>

//     <button
//       className="btn px-4 text-white"
//       style={{
//         borderRadius: "20px",
//         background: "var(--primary-color)"
//       }}
//       onClick={handleAddConversion}
//     >
//    {editMode ? "Update" : "Add"}
//     </button>

//   </div>

// </div>
//       </div>
//     </div>
//   </div>
// )}
// {showFilter && (
//   <div className="filter-dropdown">

//     <div
//       className={location.pathname === "/items" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("product");
//         setShowFilter(false);
//         navigate("/items");
//       }}
//     >
//       Product
//     </div>

//     <div
//       className={location.pathname === "/services" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Services");
//         setShowFilter(false);
//         navigate("/services");
//       }}
//     >
//       Services
//     </div>

//     <div
//       className={location.pathname === "/category" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Categories");
//         setShowFilter(false);
//         navigate("/category");
//       }}
//     >
//       Categories
//     </div>

//     <div
//       className={location.pathname === "/units" ? "active-menu" : ""}
//       onClick={() => {
//         setFilterType("Units");
//         setShowFilter(false);
//         navigate("/units");
//       }}
//     >
//       Units
//     </div>

//   </div>
// )}

// </div>


// </div>








// <div
// className="card border-0 shadow"
// style={{
// borderRadius:"20px",
// overflow:"hidden",
// minHeight:"520px"
// }}
// >


// <div className="table-responsive">
// <table className="table align-middle mb-0">

// <thead>
// <tr>

// <th
//   className="py-3 ps-4 text-white"
//   style={{
//     backgroundColor: "var(--primary-color)",
    
//   }}
// >
//   Available Units
// </th>

// <th
// className="text-white"
// style={{
// backgroundColor:"var(--primary-color)"
// }}
// >
// Primary Unit
// </th>

// <th
// className="text-white"
// style={{
// backgroundColor:"var(--primary-color)"
// }}
// >
// Secondary Unit
// </th>

// <th
// className="text-white"
// style={{
// backgroundColor:"var(--primary-color)"
// }}
// >
// Unit Conversion
// </th>

// <th
// className="text-white"
// style={{
// backgroundColor:"var(--primary-color)"
// }}
// >
// Activity
// </th>

// </tr>
// </thead>




// {/* <tbody>


// {
//   units.map((unit) => (

// <tr
//   key={unit.id}
//   style={{
//     transition:"0.3s"
//   }}
//   onMouseEnter={(e)=>
//     e.currentTarget.style.background="#fafafa"
//   }
//   onMouseLeave={(e)=>
//     e.currentTarget.style.background="#fff"
//   }
// >

// <td
//   className="ps-4 fw-semibold"
//   style={{
//     borderRight: "2px dotted #d6d6d6"
//   }}
// >
//   {unit.cat_name}
// </td>

// <td>-</td>

// <td>-</td>

// <td>-</td>

// <td>
//   <div className="d-flex gap-3">

//     <button
//       className="btn btn-sm"
//       style={{ color:"#555" }}
//     >
//       <FaEdit />
//     </button>

//     <button
//       className="btn btn-sm"
//       style={{ color:"#555" }}
//     >
//       <FaTrash />
//     </button>

//   </div>
// </td>

// </tr>

// ))
// }

// </tbody> */}
// {/* <tbody>
//   {units.map((unit) => (
//     <tr key={unit.id}>
//       <td
//         className="ps-4 py-3"
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           alignItems: "center",
//           borderBottom: "1px solid #eee"
//         }}
//       >
//         <span className="fw-semibold">
//           {unit.cat_name}
//         </span>

//         <button
//           className="btn btn-sm"
//           style={{
//             color: "red",
//             border: "none",
//             background: "transparent"
//           }}
//           onClick={() => handleDeleteUnit(unit.cat_name)}
//         >
//           <FaTrash />
//         </button>
//       </td>
//     </tr>
//   ))}
// </tbody> */}
// <tbody>
//   {units.map((unit, index) => {
//     const conversion = conversions[index];

//     return (
//       <tr key={unit.id}>

      
//         <td className="ps-3">
//           <div
//             className="d-flex justify-content-between align-items-center"
//             style={{
//               borderRight: "1px solid #000",
//               paddingRight: "10px"
//             }}
//           >
//             <span>{unit.cat_name}</span>

//             <button
//               className="btn btn-sm p-0"
//               style={{
//                 color: "#555",
//                 background: "transparent",
//                 border: "none"
//               }}
//               onClick={() => handleDeleteUnit(unit.cat_name)}
//             >
//               <FaTrash />
//             </button>
//           </div>
//         </td>


//         <td>
//           {conversion ? conversion.p_unit : ""}
//         </td>

//         <td>
//           {conversion ? conversion.s_unit : ""}
//         </td>

   
//         <td>
//           {conversion ? conversion.value : ""}
//         </td>

   
//         <td className="text-center">
//           {conversion && (
//             <div className="d-flex justify-content-center gap-2">

//             <button
//   className="btn btn-sm p-1"
//   style={{
//     border: "1px solid #0d6efd",
//     color: "#0d6efd"
//   }}
//   onClick={() => handleEditConversion(conversion)}
// >
//   <FaEdit />
// </button>

//   <button
//   className="btn btn-sm p-1"
//   style={{
//     border: "1px solid red",
//     color: "red"
//   }}
//   onClick={() => handleDeleteConversion(conversion)}
// >
//   <FaTrash />
// </button>

//             </div>
//           )}
//         </td>

//       </tr>
//     );
//   })}
// </tbody>


// </table>


// </div>



// </div>



// </div>

// )

// }


// export default Units;



import { useState, useEffect } from "react";
import { FaPlus, FaTrash, FaEdit } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { MdGridView } from "react-icons/md";
import axios from "axios";

import {
  showSuccess,
  showError,
} from "../../General/Toast";

const Units = ({ clientData }) => {
  const [units, setUnits] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [conversionToDelete, setConversionToDelete] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [conversions, setConversions] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterType, setFilterType] = useState("Products");

  const navigate = useNavigate();
  const location = useLocation();

  const [showUnitModal, setShowUnitModal] = useState(false);
  const [unitName, setUnitName] = useState("");
  const [showConversionModal, setShowConversionModal] = useState(false);

  const [conversionData, setConversionData] = useState({
    p_unit: "",
    s_unit: "",
    value: "",
  });

  const client_id = clientData.id;

  const handleDeleteConversion = (item) => {
    setConversionToDelete(item);
    setShowDeleteModal(true);
  };

  const confirmDeleteConversion = async () => {
    try {
      await axios.delete(
        `https://api.dectwinbilling.com/delete-conversion/${client_id}/${conversionToDelete.p_unit}/${conversionToDelete.s_unit}/${conversionToDelete.value}`
      );

      showSuccess("Conversion Deleted Successfully");

      fetchConversions();

      setShowDeleteModal(false);
      setConversionToDelete(null);
    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Delete Failed"
      );
    }
  };

  const fetchConversions = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-conversion/${client_id}`
      );

      setConversions(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditConversion = (item) => {
    setEditMode(true);

    setConversionData({
      id: item.id,
      p_unit: item.p_unit,
      s_unit: item.s_unit,
      value: item.value,
    });

    setShowConversionModal(true);
  };

  const handleAddUnit = async () => {
    if (!unitName.trim()) {
      alert("Enter Unit Name");
      return;
    }

    try {
      await axios.post(
        "https://api.dectwinbilling.com/add-category",
        {
          cat_name: unitName,
          cat_type: "unit",
          client_id,
        }
      );

      showSuccess("Unit Added Successfully");

      setUnitName("");
      setShowUnitModal(false);

      fetchUnits();
    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Something went wrong"
      );
    }
  };

  const handleAddConversion = async () => {
    try {
      if (
        !conversionData.p_unit ||
        !conversionData.s_unit ||
        !conversionData.value
      ) {
        showError("Fill all fields");
        return;
      }

      if (editMode) {
        await axios.put(
          "https://api.dectwinbilling.com/edit-conversion",
          {
            p_unit: conversionData.p_unit,
            s_unit: conversionData.s_unit,
            value: conversionData.value,
            client_id,
          }
        );

        showSuccess("Conversion Updated Successfully");
      } else {
        await axios.post(
          "https://api.dectwinbilling.com/add-conversion",
          {
            p_unit: conversionData.p_unit,
            s_unit: conversionData.s_unit,
            value: conversionData.value,
            client_id,
          }
        );

        showSuccess("Conversion Added Successfully");
      }

      fetchConversions();

      setConversionData({
        p_unit: "",
        s_unit: "",
        value: "",
      });

      setEditMode(false);
      setShowConversionModal(false);
    } catch (error) {
      showError(
        error.response?.data?.message ||
          "Something went wrong"
      );
    }
  };

  const handleDeleteUnit = async (unitName) => {
    try {
      await axios.delete(
        `https://api.dectwinbilling.com/delete-unit/${client_id}/${unitName}`
      );

      fetchUnits();
      showSuccess("Unit Deleted Successfully");
    } catch (error) {
      alert(
        error.response?.data?.message ||
          "Delete Failed"
      );
    }
  };

  const fetchUnits = async () => {
    try {
      const response = await axios.get(
        `https://api.dectwinbilling.com/fetch-unit/${client_id}`
      );

      setUnits(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchUnits();
    fetchConversions();
  }, []);

  return (
    <div
      className="container-fluid min-vh-100 px-2 px-sm-3 py-3"
      style={{
        background: "#f1f3f8",
      }}
    >
      {/* ================= HEADER ================= */}
{/* ================= HEADER ================= */}
<div className="card border-0 shadow-sm rounded-4 mb-3">
  <div className="card-body p-2 p-sm-3 p-md-4">

    <div className="row g-2 g-md-3 align-items-center">

      {/* ================= TITLE ================= */}
      <div className="col-12 col-md">
        <div>
          <h4 className="fw-bold mb-1 fs-5">
            Units
          </h4>

          <small
            className="text-muted d-block"
            style={{
              fontSize: "11px",
            }}
          >
            Manage units and unit conversions
          </small>
        </div>
      </div>

      {/* ================= ACTION BUTTONS ================= */}
      <div className="col-12 col-md-auto">
        <div className="d-flex align-items-center gap-1 gap-sm-2 w-100">

          {/* ADD UNIT */}
          <button
            type="button"
            className="btn text-white fw-semibold d-flex align-items-center justify-content-center flex-grow-1 flex-md-grow-0"
            style={{
              background: "var(--primary-color)",
              borderRadius: "9px",
              height: "38px",
              padding: "0 10px",
              fontSize: "12px",
              whiteSpace: "nowrap",
              minWidth: "0",
            }}
            onClick={() => setShowUnitModal(true)}
          >
            <FaPlus
              className="me-1"
              size={9}
            />
            Add Unit
          </button>

          {/* ADD CONVERSION */}
          <button
            type="button"
            className="btn text-white fw-semibold d-flex align-items-center justify-content-center flex-grow-1 flex-md-grow-0"
            style={{
              background: "var(--primary-color)",
              borderRadius: "9px",
              height: "38px",
              padding: "0 10px",
              fontSize: "12px",
              whiteSpace: "nowrap",
              minWidth: "0",
            }}
            onClick={() => {
              setEditMode(false);

              setConversionData({
                p_unit: "",
                s_unit: "",
                value: "",
              });

              setShowConversionModal(true);
            }}
          >
            <FaPlus
              className="me-1"
              size={9}
            />
            Add Conversion
          </button>

          {/* GRID / FILTER */}
          <button
            type="button"
            className="btn btn-light border shadow-sm d-flex align-items-center justify-content-center flex-shrink-0"
            style={{
              width: "38px",
              minWidth: "38px",
              height: "38px",
              borderRadius: "9px",
              padding: "0",
            }}
            onClick={() =>
              setShowFilter(!showFilter)
            }
          >
            <MdGridView size={18} />
          </button>

        </div>
      </div>

    </div>

    {/* ================= FILTER ================= */}
    {showFilter && (
      <div className="position-relative">
        <div
          className="position-absolute end-0 mt-2 bg-white shadow rounded-3 border overflow-hidden"
          style={{
            zIndex: 1050,
            minWidth: "180px",
            maxWidth: "100%",
          }}
        >

          <div
            className={`px-3 py-2 ${
              location.pathname === "/items"
                ? "bg-light fw-semibold"
                : ""
            }`}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setFilterType("product");
              setShowFilter(false);
              navigate("/items");
            }}
          >
            Product
          </div>

          <div
            className={`px-3 py-2 ${
              location.pathname === "/services"
                ? "bg-light fw-semibold"
                : ""
            }`}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setFilterType("Services");
              setShowFilter(false);
              navigate("/services");
            }}
          >
            Services
          </div>

          <div
            className={`px-3 py-2 ${
              location.pathname === "/category"
                ? "bg-light fw-semibold"
                : ""
            }`}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setFilterType("Categories");
              setShowFilter(false);
              navigate("/category");
            }}
          >
            Categories
          </div>

          <div
            className={`px-3 py-2 ${
              location.pathname === "/units"
                ? "bg-light fw-semibold"
                : ""
            }`}
            style={{
              cursor: "pointer",
            }}
            onClick={() => {
              setFilterType("Units");
              setShowFilter(false);
              navigate("/units");
            }}
          >
            Units
          </div>

        </div>
      </div>
    )}

  </div>
</div>
      {/* ================= TABLE CARD ================= */}
      <div
        className="card border-0 shadow-sm rounded-4"
        style={{
          overflow: "hidden",
          minHeight: "520px",
        }}
      >
        <div className="card-body p-0">

          <div className="table-responsive">
            <table
              className="table table-hover align-middle mb-0"
              style={{
                minWidth: "720px",
              }}
            >
              <thead>
                <tr>
                  <th
                    className="py-3 ps-3 ps-md-4 text-white fw-semibold"
                    style={{
                      backgroundColor:
                        "var(--primary-color)",
                    }}
                  >
                    Available Units
                  </th>

                  <th
                    className="py-3 text-white fw-semibold"
                    style={{
                      backgroundColor:
                        "var(--primary-color)",
                    }}
                  >
                    Primary Unit
                  </th>

                  <th
                    className="py-3 text-white fw-semibold"
                    style={{
                      backgroundColor:
                        "var(--primary-color)",
                    }}
                  >
                    Secondary Unit
                  </th>

                  <th
                    className="py-3 text-white fw-semibold"
                    style={{
                      backgroundColor:
                        "var(--primary-color)",
                    }}
                  >
                    Unit Conversion
                  </th>

                  <th
                    className="py-3 text-white fw-semibold text-center"
                    style={{
                      backgroundColor:
                        "var(--primary-color)",
                    }}
                  >
                    Activity
                  </th>
                </tr>
              </thead>

              <tbody>
                {units.map((unit, index) => {
                  const conversion =
                    conversions[index];

                  return (
                    <tr key={unit.id}>

                      {/* AVAILABLE UNIT */}
                      <td className="ps-3 ps-md-4 py-3">
                        <div className="d-flex align-items-center justify-content-between gap-3">

                          <span className="fw-semibold text-dark text-nowrap">
                            {unit.cat_name}
                          </span>

                          <button
                            type="button"
                            className="btn btn-sm btn-light border rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                            style={{
                              width: "32px",
                              height: "32px",
                            }}
                            onClick={() =>
                              handleDeleteUnit(
                                unit.cat_name
                              )
                            }
                            title="Delete Unit"
                          >
                            <FaTrash
                              size={13}
                              className="text-danger"
                            />
                          </button>

                        </div>
                      </td>

                      {/* PRIMARY */}
                      <td className="py-3">
                        {conversion ? (
                          <span className="badge bg-light text-dark border fw-medium px-3 py-2">
                            {conversion.p_unit}
                          </span>
                        ) : (
                          <span className="text-muted">
                            —
                          </span>
                        )}
                      </td>

                      {/* SECONDARY */}
                      <td className="py-3">
                        {conversion ? (
                          <span className="badge bg-light text-dark border fw-medium px-3 py-2">
                            {conversion.s_unit}
                          </span>
                        ) : (
                          <span className="text-muted">
                            —
                          </span>
                        )}
                      </td>

                      {/* VALUE */}
                      <td className="py-3 fw-semibold">
                        {conversion ? (
                          conversion.value
                        ) : (
                          <span className="text-muted">
                            —
                          </span>
                        )}
                      </td>

                      {/* ACTIONS */}
                      <td className="py-3 text-center">
                        {conversion && (
                          <div className="d-flex justify-content-center align-items-center gap-2">

                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary rounded-3 d-flex align-items-center justify-content-center"
                              style={{
                                width: "34px",
                                height: "34px",
                              }}
                              onClick={() =>
                                handleEditConversion(
                                  conversion
                                )
                              }
                              title="Edit"
                            >
                              <FaEdit size={13} />
                            </button>

                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger rounded-3 d-flex align-items-center justify-content-center"
                              style={{
                                width: "34px",
                                height: "34px",
                              }}
                              onClick={() =>
                                handleDeleteConversion(
                                  conversion
                                )
                              }
                              title="Delete"
                            >
                              <FaTrash size={13} />
                            </button>

                          </div>
                        )}
                      </td>

                    </tr>
                  );
                })}

                {units.length === 0 && (
                  <tr>
                    <td
                      colSpan="5"
                      className="text-center py-5"
                    >
                      <div className="text-muted">
                        No units available
                      </div>
                    </td>
                  </tr>
                )}

              </tbody>
            </table>
          </div>

        </div>
      </div>

      {/* ================= DELETE CONVERSION MODAL ================= */}
      {showDeleteModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            background: "rgba(0,0,0,0.55)",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog modal-dialog-centered px-2">
            <div className="modal-content border-0 rounded-4 shadow">

              <div className="modal-body text-center p-4 p-md-5">

                <div
                  className="mx-auto mb-3 rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{
                    width: "60px",
                    height: "60px",
                  }}
                >
                  <FaTrash
                    className="text-danger"
                    size={22}
                  />
                </div>

                <h4 className="fw-bold mb-2">
                  Delete Conversion
                </h4>

                <p className="text-muted mb-4">
                  Are you sure you want to delete this
                  conversion?
                </p>

                <div className="d-grid d-sm-flex justify-content-center gap-2">

                  <button
                    type="button"
                    className="btn btn-light border px-4 rounded-3"
                    onClick={() => {
                      setShowDeleteModal(false);
                      setConversionToDelete(null);
                    }}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn btn-danger px-4 rounded-3"
                    onClick={
                      confirmDeleteConversion
                    }
                  >
                    Delete
                  </button>

                </div>

              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================= ADD UNIT MODAL ================= */}
      {showUnitModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{
            background: "rgba(0,0,0,0.55)",
            zIndex: 1055,
          }}
        >
          <div className="modal-dialog modal-dialog-centered px-2">
            <div
              className="modal-content border-0 shadow rounded-4"
              style={{
                background: "#f4f1f4",
              }}
            >
              <div className="modal-body p-3 p-sm-4 p-md-5">

                <h3 className="text-center fw-bold mb-4">
                  Add Unit
                </h3>

                <div className="mb-4">
                  <label className="form-label fw-semibold mb-2">
                    Unit Name
                  </label>

                  <div
                    className="d-flex align-items-center px-3"
                    style={{
                      minHeight: "52px",
                      background: "#ddd9dd",
                      borderRadius: "14px",
                    }}
                  >
                    <input
                      type="text"
                      className="form-control border-0 bg-transparent shadow-none px-0"
                      placeholder="Enter Unit Name"
                      value={unitName}
                      onChange={(e) =>
                        setUnitName(
                          e.target.value
                        )
                      }
                    />
                  </div>
                </div>

                <div className="d-grid d-sm-flex justify-content-center gap-2">

                  <button
                    type="button"
                    className="btn btn-light border px-4 rounded-3"
                    onClick={() =>
                      setShowUnitModal(false)
                    }
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    className="btn text-white px-4 rounded-3"
                    style={{
                      background:
                        "var(--primary-color)",
                    }}
                    onClick={handleAddUnit}
                  >
                    Add
                  </button>

                </div>

              </div>
            </div>
          </div>
        </div>
      )}

      {/* ================= CONVERSION MODAL ================= */}
   {showConversionModal && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    style={{
      background: "rgba(15, 23, 42, 0.65)",
      zIndex: 1055,
      backdropFilter: "blur(3px)",
    }}
  >
    <div className="modal-dialog modal-dialog-centered modal-lg px-2 px-sm-3">
      <div
        className="modal-content border-0 shadow-lg overflow-hidden"
        style={{
          borderRadius: "24px",
          background: "#ffffff",
        }}
      >

        {/* ================= HEADER ================= */}
        <div
          className="px-3 px-sm-4 px-md-5 py-3 py-md-4"
          style={{
            background: "#f8f9fc",
            borderBottom: "1px solid #eeeeee",
          }}
        >
          <div className="d-flex align-items-center justify-content-between gap-3">

            <div className="d-flex align-items-center gap-3">

              {/* ICON */}
              <div
                className="d-flex align-items-center justify-content-center flex-shrink-0"
                style={{
                  width: "46px",
                  height: "46px",
                  borderRadius: "14px",
                  background: "var(--primary-color)",
                  color: "#fff",
                }}
              >
                <FaEdit size={18} />
              </div>

              <div>
                <h4 className="fw-bold mb-1">
                  {editMode
                    ? "Edit Unit Conversion"
                    : "Add Unit Conversion"}
                </h4>

                <small className="text-muted">
                  {editMode
                    ? "Update your unit conversion details"
                    : "Create a new unit conversion"}
                </small>
              </div>

            </div>

            {/* CLOSE */}
            <button
              type="button"
              className="btn btn-light border-0 d-flex align-items-center justify-content-center flex-shrink-0"
              style={{
                width: "38px",
                height: "38px",
                borderRadius: "50%",
                fontSize: "20px",
                color: "#6c757d",
              }}
              onClick={() =>
                setShowConversionModal(false)
              }
              aria-label="Close"
            >
              ×
            </button>

          </div>
        </div>

        {/* ================= BODY ================= */}
        <div className="modal-body p-3 p-sm-4 p-md-5">

          <div className="row g-3 g-md-4">

            {/* PRIMARY UNIT */}
            <div className="col-12 col-md-6">
              <label className="form-label fw-semibold mb-2">
                Primary Unit
              </label>

              <select
                className="form-select shadow-none"
                value={conversionData.p_unit}
                disabled={editMode}
                onChange={(e) =>
                  setConversionData({
                    ...conversionData,
                    p_unit: e.target.value,
                  })
                }
                style={{
                  height: "54px",
                  borderRadius: "12px",
                  background: "#f7f8fa",
                  border: "1px solid #e2e5e9",
                  fontSize: "15px",
                  cursor: editMode
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                <option value="">
                  Select Primary Unit
                </option>

                {units.map((unit) => (
                  <option
                    key={unit.id}
                    value={unit.cat_name}
                  >
                    {unit.cat_name}
                  </option>
                ))}
              </select>

              {editMode && (
                <small className="text-muted mt-1 d-block">
                  Primary unit cannot be changed while editing.
                </small>
              )}
            </div>

            {/* SECONDARY UNIT */}
            <div className="col-12 col-md-6">
              <label className="form-label fw-semibold mb-2">
                Secondary Unit
              </label>

              <select
                className="form-select shadow-none"
                value={conversionData.s_unit}
                disabled={editMode}
                onChange={(e) =>
                  setConversionData({
                    ...conversionData,
                    s_unit: e.target.value,
                  })
                }
                style={{
                  height: "54px",
                  borderRadius: "12px",
                  background: "#f7f8fa",
                  border: "1px solid #e2e5e9",
                  fontSize: "15px",
                  cursor: editMode
                    ? "not-allowed"
                    : "pointer",
                }}
              >
                <option value="">
                  Select Secondary Unit
                </option>

                {units.map((unit) => (
                  <option
                    key={unit.id}
                    value={unit.cat_name}
                  >
                    {unit.cat_name}
                  </option>
                ))}
              </select>

              {editMode && (
                <small className="text-muted mt-1 d-block">
                  Secondary unit cannot be changed while editing.
                </small>
              )}
            </div>

            {/* CONVERSION VALUE */}
            <div className="col-12">
              <label className="form-label fw-semibold mb-2">
                Unit Conversion
              </label>

              <div className="position-relative">
                <input
                  type="text"
                  className="form-control shadow-none pe-4"
                  placeholder="Enter conversion value"
                  value={conversionData.value}
                  onChange={(e) =>
                    setConversionData({
                      ...conversionData,
                      value: e.target.value,
                    })
                  }
                  style={{
                    height: "54px",
                    borderRadius: "12px",
                    background: "#f7f8fa",
                    border: "1px solid #e2e5e9",
                    fontSize: "15px",
                  }}
                />
              </div>

              <small className="text-muted mt-2 d-block">
                Enter the conversion value between the selected units.
              </small>
            </div>

          </div>

          {/* ================= FOOTER ================= */}
          <div
            className="mt-4 pt-4"
            style={{
              borderTop: "1px solid #eeeeee",
            }}
          >
            <div className="d-grid d-sm-flex justify-content-end gap-2">

              <button
                type="button"
                className="btn btn-light border fw-semibold px-4"
                style={{
                  minHeight: "46px",
                  borderRadius: "11px",
                  minWidth: "100px",
                }}
                onClick={() =>
                  setShowConversionModal(false)
                }
              >
                Cancel
              </button>

              <button
                type="button"
                className="btn text-white fw-semibold px-4 shadow-sm"
                style={{
                  minHeight: "46px",
                  borderRadius: "11px",
                  minWidth: "110px",
                  background:
                    "var(--primary-color)",
                }}
                onClick={handleAddConversion}
              >
                {editMode ? "Update" : "Add"}
              </button>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default Units;

